export enum AllowedGroups {
    CORALINE_PROXY_ADMIN = <any>"CORALINE_PROXY_ADMIN",
    CORALINE_PROXY_READ = <any>"CORALINE_PROXY_READ"
 }